import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import NetworkTable, { ColumnConfig, ColumnType, NetworkTableRow } from '../../components/InterfacesTable/NetworkTable/NetworkTable';
import { Box, Container, Checkbox, FormControlLabel } from '@mui/material';
import FilterSearchAddBar from '../../components/FilterSearchAddBar/FilterSearchAddBar';
import AddEditInterfaceModal from "../../components/Modals/AddEditInterfaceModal";
import LabelValueDisplay from "../../components/LabelValue/LabelValueDisplay";
import { getAllNetworksData, deleteLanData, updateWanInterfaceData, addWanInterfaceData, getWanProfilesData, getFreeLanAccessInterfacesData, getDeviceLinkStatusData, getStaticRoutesData, deleteStaticRouteData, getLanIpRangesData, getDhcpReservationsData, getDeleteDhcpReservationData, getEnableDisableDnsProxyData, getLanMulticastData, getSetLanMulticastData, getDnsProxyConfigData, getDeleteDnsProxyConfigData } from '../../../../../actions/Users/authenticateOpenEdgeService';
import { ADD_WAN_INTERFACE, DELETE_LAN, UPDATE_WAN_INTERFACE, GET_ALL_NETWORKS, GET_STATIC_ROUTES, DELETE_STATIC_ROUTE, GET_DHCP_RESERVATIONS, GET_DELETE_DHCP_RESERVATION, GET_ENABLE_DISABLE_DNS_CASHE, GET_LAN_MULTICAST, GET_SET_LAN_MULTICAST, GET_DNS_PROXY_CONFIG, GET_DELETE_DNS_PROXY_CONFIG } from '../../../../../actions/types';
import _ from "lodash";
import { getSubnetMask } from 'subnet-cidr-calculator';
import DeleteWANProfileModal from '../../components/Modals/DeleteProfileModal';
import { Netmask } from 'netmask';
import ToggleRadioGroup from '../../components/TottleRadioGroup/ToggleRadioGroup';
import CustomLoader from "../../../../../components/Loader/CustomLoader";
import TabsComponent from '../../../../../components/NewTabs';
import CheckboxWithAction from '../../components/CheckboxWithAction/CheckboxWithAction';
import { validateIp, validateMac, validateIpOrSubnet, validateDomain, ipv4Regex, netmaskToCIDR, cidrToNetmask } from "../../../../../utils/util";
import { toast } from 'react-toastify';
import { useConfigAutoRefresh } from "../../hooks/useConfigAutoRefresh";

const LANTab = (props) => {
  const { getAllNetworksData, getAllNetworks, selectedRow, deleteLanData, deleteLan, updateWanInterfaceData, addWanInterfaceData, addWanInterface, updateWanInterface, getWanProfilesData, getWanProfiles,
    getAllNetworksLoading, getWanProfilesLoading, addWanInterfaceLoading, updateWanInterfaceLoading, deleteLANLoading, getFreeLanAccessInterfacesData, getFreeLanAccessInterfaces, getFreeLanAccessInterfacesLoading, deviceInfo, refreshIconClicked, setRefreshIconClicked, getDeviceLinkStatusData, deviceLinkStatusLoading,
    getStaticRoutesData, getStaticRoutes, getStaticRoutesLoading, deleteStaticRouteData, deleteStaticRoute, deleteStaticRouteLoading, getLanIpRangesData, getLanIpRanges, getLanIpRangesLoading, getDhcpReservationsData, getDhcpReservations, getDhcpReservationsLoading, getDeleteDhcpReservationData, getDeleteDhcpReservation, getDeleteDhcpReservationLoading,
    getEnableDisableDnsProxyData, getEnableDisableDnsProxy, getEnableDisableDnsProxyLoading, getLanMulticastData, getLanMulticast, getLanMulticastLoading, getSetLanMulticastData, getSetLanMulticast, getSetLanMulticastLoading, getDnsProxyConfigData, getDnsProxyConfig, getDnsProxyConfigLoading, getDeleteDnsProxyConfigData, getDeleteDnsProxyConfigLoading, getDeleteDnsProxyConfig,
    notifyConfigAction, notifyConfigActionComplete,
  } = props;
  const dispatch = useDispatch();
  const [lans, setLans] = useState<any>([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddAddressModalOpen, setIsAddAddressModalOpen] = useState(false);
  const [isAddDomainModalOpen, setIsAddDomainModalOpen] = useState(false);
  const [isAddDnsServerModalOpen, setIsAddDnsServerModalOpen] = useState(false);
  const [isStaticRoutesModalOpen, setIsStaticRoutesModalOpen] = useState(false);
  const [vidError, setVidError] = useState("");
  const [formData, setFormData] = useState<any>({isCaptive: 'disabled'});
  const [isEditPopup, setIsEditPopup] = useState(false);
  const [filters, setFilters] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [wanProfiles, setWanProfiles] = useState<any>([]);
  const [row, setRow] = useState<any>({});
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isStaticRouteDeleteModalOpen, setIsStataicRouteDeleteModalOpen] = useState(false);
  const [isDhcpReservationDeleteModalOpen, setIsDhcpReservationDeleteModalOpen] = useState(false);
  const [isDnsProxyDeleteModalOpen, setIsDnsProxyDeleteModalOpen] = useState(false);
  const [ipError, setIpError] = useState("");
  const [dhcpGatewayError, setDhcpGatewayError] = useState("");
  const [dnsError, setDnsError] = useState("");
  const [ipPoolsError, setIpPoolsError] = useState("");
  const [gatewayError, setGatewayError] = useState<any>(false);
  const [destinationAddressError, setDestinationAddressError] = useState<string>("");
  const [sourceAddressError, setSourceAddressError] = useState<string>("");
  const [filteredLans, setFilteredLans] = useState<NetworkTableRow[]>([]);
  const [freeLanAccessInterfaces, setFreeLanAccessInterfaces] = useState<any>([]);

  const [appliedInitialFilter, setAppliedInitialFilter] = useState(false);

  const [lanFilterAliases, setLanFilterAliases] = useState<string[] | null>(null);
  const [activeTab, setActiveTab] = useState('networks');
  const [dnsHostOverrideEnabled, setDnsHostOverrideEnabled] = useState(true);
  const [dnsCasheEnabled, setDnsCasheEnabled] = useState(true);
  const [dnsForwarderEnabled, setDNSForwarderEnabled] = useState(true);
  const [ipRanges, setIpRanges] = useState<any>([]);
  const [ipAddError, setIpAddError] = useState<any>('');
  const [macAddError, setMacAddError] = useState<any>('');
  const [descError, setDescError] = useState<any>('');
  const [domainError, setDomainError] = useState('');

  const [aliasError, setAliasError] = useState('');
  const [columns, setColumns] = useState<ColumnConfig[]>([
    {
      label: "Network Alias",
      key: "network_alias",
      type: ColumnType.textWithService,
      maxWidth: "145px",
    },
    {
      label: "VLAN ID",
      key: "vlan_id",
      type: ColumnType.text,
      maxWidth: "63px",
    },
    // {
    //   label: "Link Type",
    //   key: "link_type",
    //   type: ColumnType.text,
    //   maxWidth: "102px",
    // },
    {
      label: "WAN Profile",
      key: "profile_name",
      type: ColumnType.text,
      maxWidth: "118px",
    },
    {
      label: "Interface IP / Subnet",
      key: "interface_ip",
      type: ColumnType.combinedColumn,
      maxWidth: "151px",
      combinedColumnList: ["interface_ip", "netmask"],
      columnListSeperator: " / "
    },
    {
      label: "DHCP",
      key: "dhcp",
      type: ColumnType.boolean,
      maxWidth: "63px",
      booleanList: ["Enabled", "Disabled"]
    },
    {
      label: "Gateway Address",
      key: "dhcp_gateway",
      type: ColumnType.text,
      maxWidth: "102px",
    },
    {
      label: "DNS Servers",
      key: "dns_server",
      type: ColumnType.text,
      maxWidth: "102px",
    },
    {
      label: "Actions",
      key: "custom",
      type: ColumnType.actions,
      actions: ["setting", "delete"],
      maxWidth: "72px",
    }
  ])
  const [dhcpColumns, setDhcpColumns] = useState<ColumnConfig[]>([
    {
      label: "Name",
      key: "name",
      type: ColumnType.text,
      maxWidth: "145px",
    },
    {
      label: "MAC Address",
      key: "mac",
      type: ColumnType.text,
      maxWidth: "63px",
    },
    {
      label: "IP Address",
      key: "ip",
      type: ColumnType.text,
      maxWidth: "118px",
    },
    {
      label: "Description",
      key: "desc",
      type: ColumnType.text,
      maxWidth: "151px",
    },
    {
      label: "Bypass Captive",
      key: "bypasscaptive",
      type: ColumnType.boolean,
      maxWidth: "63px",
      booleanList: ["Enabled", "Disabled"]
    },
    {
      label: "Access Network",
      key: "vlan_name",
      type: ColumnType.text,
      maxWidth: "63px"
    },
    {
      label: "Actions",
      key: "custom",
      type: ColumnType.actions,
      actions: ["setting", "delete"],
      maxWidth: "72px",
    }
  ])
  const [domainColumns, setDomainColumns] = useState<ColumnConfig[]>([
    {
      label: "IP Address",
      key: "ip",
      type: ColumnType.text,
      maxWidth: "145px",
    },
    {
      label: "Host Name/Domain",
      key: "domain",
      type: ColumnType.text,
      maxWidth: "63px",
    },
    {
      label: "Actions",
      key: "custom",
      type: ColumnType.actions,
      actions: ["setting", "delete"],
      maxWidth: "72px",
      width: '10%'
    }
  ])
  const [dnsServerColumns, setDnsServerColumns] = useState<ColumnConfig[]>([
    {
      label: "DNS Servers",
      key: "server",
      type: ColumnType.text,
      maxWidth: "145px",
    },
    {
      label: "Actions",
      key: "custom",
      type: ColumnType.actions,
      actions: ["setting", "delete"],
      maxWidth: "72px",
      width: '10%'
    }
  ])
  const [staticRoutesColumns, setStaticRoutesColumns] = useState<ColumnConfig[]>([
    {
      label: "Source Address",
      key: "source_address",
      type: ColumnType.text,
      maxWidth: "145px",
    },
    {
      label: "Destination Address",
      key: "destination_address",
      type: ColumnType.text,
      maxWidth: "145px",
    },
    {
      label: "Gateway IP",
      key: "gateway",
      type: ColumnType.text,
      maxWidth: "145px",
    },
    {
      label: "Actions",
      key: "custom",
      type: ColumnType.actions,
      actions: ["setting", "delete"],
      maxWidth: "72px",
    }
  ])
  const [multicastColumns, setMulticastColumns] = useState<ColumnConfig[]>([
    {
      label: "Network Alias",
      key: "vlan_name",
      type: ColumnType.text,
      maxWidth: "145px",
    },
    {
      label: "Multicast",
      key: "multicast",
      type: ColumnType.sliderText,
      maxWidth: "145px",
    }
  ])

  const getIpPlusOne = (ip: string) => {
    const parts = ip.split('.').map(Number);
    parts[3] += 1;
    return parts.join('.');
  };

  const generateIpPools = (currentFormData: any) => {
    const updatedFields: any = { dhcp: true };

    if (!currentFormData.dhcp_gateway) {
      updatedFields.dhcp_gateway = currentFormData.interface_ip?.split("/")[0] || "";
    }
    if (!currentFormData.ip_pools && currentFormData.interface_ip) {
      const [ip] = currentFormData.interface_ip.split("/");
      const ipPoolStart = getIpPlusOne(ip);
      const block = new Netmask(currentFormData.interface_ip);
      updatedFields.ip_pools = `${ipPoolStart}-${block.last}`;
    }
    if (!currentFormData.dns_server && currentFormData.isCaptive !== "enabled") {
      updatedFields.dns_server = "8.8.8.8";
    }

    return updatedFields;
  };

  const isGatewayInRange = (gateway: string, lanRanges: string[][]): boolean => {
    if (!gateway || !Array.isArray(lanRanges)) return false;

    const ipToNumber = (ip: string) =>
      ip.split(".").reduce((acc, octet) => (acc << 8) + parseInt(octet), 0);

    const gatewayNum = ipToNumber(gateway);

    return lanRanges.some(([start, end]) => {
      const startNum = ipToNumber(start);
      const endNum = ipToNumber(end);
      return gatewayNum >= startNum && gatewayNum <= endNum;
    });
  };

  const handleChange = (key: string) => (e: any) => {
    const value = key === "dhcp" ? e.target.checked : e.target.value;
    if (key == 'is_mgmt') {
      if (value == 'enabled') {
        const updatedFields = {
          is_mgmt: value,
          isCaptive: 'disabled',
          ...generateIpPools(formData),
          dns_server: "8.8.8.8", 
        };

        setFormData((prev) => ({
          ...prev,
          ...updatedFields,
        }));
        return;
      }
    }
    if (key == 'link_type' && value != 'LAN Trunk') {
      setFormData({ ...formData, is_mgmt: 'disabled' })
    }
    if (key === "isCaptive") {
      const isCaptiveEnabled = value === "enabled";
      setFormData((prev) => ({
        ...prev,
        isCaptive: value,
        dns_server: isCaptiveEnabled
          ? prev.dhcp_gateway || ''
          : prev.dhcp
          ? '8.8.8.8'
          : ''

      }));
      return;
    }
    setFormData((prev) => ({
      ...prev,
      [key]: value,
      ...(key === "dhcp"
  ? {
      dns_server:
        value && formData?.isCaptive !== "enabled" && !formData?.dns_server
          ? "8.8.8.8"
          // : !value && formData?.isCaptive !== "enabled"
          // ? ""
          : formData?.dns_server
    }
  : {})
,
    }));

    if (key === "network_alias") {
      if (value === "") {
        setAliasError("");
      } else if (!/^[a-zA-Z]/.test(value)) {
        setAliasError("Must start with a letter.");
      } else if (!/^[a-zA-Z0-9]*$/.test(value)) {
        setAliasError("Only letters and numbers allowed.");
      } else {
        setAliasError("");
      }
    }
    if (key === "vlan_id") {
      if (!value || value.trim() === "") {
        setFormData((prev) => ({
          ...prev,
          vlan_id: '',
          interface_ip: '',
          ip_pools: '',
          dhcp_gateway: '',
          dns_server: ''
        }));
        setVidError("");
        return;
      }
      const numberValue = Number(value);
      let error = "";

      if (numberValue < 1 || numberValue > 4095) {
        error = "VLAN ID must be between 1 and 4095.";
      } else {
        const isDuplicate = lans?.some(
          (iface) => iface?.vlan_id?.toString() === value && iface?.id !== formData?.id
        );
        if (isDuplicate) {
          error = "This VLAN ID already exists.";
        }
      }

      setVidError(error);

      if (!error) {
        const thirdOctet = numberValue <= 254 ? Number(value) : Number(value) % 254;
        const base = `192.168.${thirdOctet}.1`;
        const cidr = 24;
        const interfaceIp = `${base}/${cidr}`;
        const block = new Netmask(interfaceIp);        const ipPoolStart = getIpPlusOne(base);
        const ipPoolEndAddr = block.last;
        const autoGeneratedIpPools = `${ipPoolStart}-${ipPoolEndAddr}`;

        setFormData((prev) => ({
          ...prev,
          vlan_id: value,
          interface_ip: interfaceIp,
          ip_pools: autoGeneratedIpPools,
          dhcp_gateway: base,
          dns_server: formData?.isCaptive == 'enabled' ? base : '8.8.8.8'
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          vlan_id: value,
          interface_ip: '',
          ip_pools: '',
          dhcp_gateway: '',
          dns_server: ''
        }));
      }
      return;
    }

    if (key === "interface_ip") {
      const trimmed = value.trim();
      const [ipRaw, cidrRaw] = trimmed.split("/");
      const ip = ipRaw?.trim();
      const cidr = cidrRaw?.trim();

      let error = "";

      if (!ipv4Regex.test(ip)) {
        error = "Invalid IP address format.";
      } else if (!cidr) {
        error = "Subnet (e.g. /24) is required.";
      } else if (cidr !== undefined) {
        const cidrNum = Number(cidr);
        if (
          isNaN(cidrNum) || cidrNum < 1 || cidrNum > 32 || !Number.isInteger(cidrNum)
        ) {
          error = "CIDR must be a number between 0 and 32.";
        } else {
          const interfaceIp = `${ip}/${cidrNum}`;
          const block = new Netmask(interfaceIp);
          const ipPoolStart = getIpPlusOne(ip);
          const ipPoolEnd = block.last;
          const autoGeneratedIpPools = `${ipPoolStart}-${ipPoolEnd}`;

          setFormData((prev) => ({
            ...prev,
            interface_ip: interfaceIp,
            dhcp_gateway: ip,
            ip_pools: autoGeneratedIpPools,
          }));
        }
      }
      setIpError(error);
    }

    if (key === "dhcp_gateway") {
      const error =
        value && !ipv4Regex.test(value)
          ? "Invalid Gateway IP (e.g. 192.168.81.1)"
          : "";
      setDhcpGatewayError?.(error);
      return;
    }

    if (key === "dns_server") {
      const dnsList = value.split(",").map((dns: string) => dns.trim());
      const invalidDns = dnsList.find((dns: string) => !ipv4Regex.test(dns));
      const error = invalidDns ? "Invalid DNS (e.g. 8.8.8.8)" : "";
      setDnsError?.(error);
      return;
    }

    if (key === "ip_pools") {
      const ipRangeRegex = /^(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})-(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})$/;
      const ipv4ToNumber = (ip: string) =>
        ip.split(".").reduce((acc, octet) => (acc << 8) + parseInt(octet), 0);

      const isValidIp = (ip: string) => {
        const [a, b, c, d] = ip.split(".").map(Number);
        return (
          a >= 0 && a <= 255 &&
          b >= 0 && b <= 255 &&
          c >= 0 && c <= 255 &&
          d >= 0 && d <= 255
        );
      };

      const ranges = value.split(",").map((r) => r.trim());
      let error = "";

      for (let range of ranges) {
        if (!ipRangeRegex.test(range)) {
          error = "Invalid format in range (e.g. 192.168.1.10-192.168.1.50)";
          break;
        }

        const [start, end] = range.split("-").map((ip) => ip.trim());

        if (!isValidIp(start) || !isValidIp(end)) {
          error = "Invalid IP address in range. Ensure both start and end are valid IP addresses.";
          break;
        }

        const startNum = ipv4ToNumber(start);
        const endNum = ipv4ToNumber(end);

        if (startNum >= endNum) {
          error = "Start IP must be less than End IP in range";
          break;
        }
      }

      setIpPoolsError(error);
      return;
    }
    if (key === "dhcp") {
      const dhcpEnabled = value;
      let updatedFields: any = { dhcp: dhcpEnabled };

      if (dhcpEnabled) {
        updatedFields = {
          ...updatedFields,
          ...generateIpPools(formData),
        };
      }

      setFormData((prev) => ({
        ...prev,
        ...updatedFields,
      }));
      return;
    }
    if (key === "gateway") {
      let error = "";

      if (!value) {
        error = "Gateway IP is required";
      } else if (!ipv4Regex.test(value)) {
        error = "Invalid Gateway IP (e.g. 192.168.1.1)";
      } else {
        const inRange = isGatewayInRange(value, ipRanges?.network_subnets);
        if (!inRange) {
          error = "Gateway IP must fall within the LAN ranges";
        }
      }

      setGatewayError?.(error);

      if (!error) {
        setFormData((prev) => ({
          ...prev,
          gateway: value,
        }));
      }

      return;
    }
    if (key === "destination_address") {
      const error = value ? validateIpOrSubnet(value) : "Destination address is required.";
      setDestinationAddressError(error);
      if (!error) {
        setFormData((prev) => ({ ...prev, destination_address: value }));
      }
      return;
    }

    if (key === "source_address") {
      const error = value ? validateIpOrSubnet(value) : ""; // optional
      setSourceAddressError(error);
      if (!error) {
        setFormData((prev) => ({ ...prev, source_address: value }));
      }
      return;
    }
    
    if (key === "ip") {
      let error = validateIp(value);

      if (!error) {

        const selectedNetwork = ipRanges?.networks?.find(
          (net) => net.network_alias === formData?.vlan_name
        );

        if (selectedNetwork?.network_range) {
          const inRange = isGatewayInRange(value, [selectedNetwork.network_range]);
          if (!inRange) {
            error = `IP Range: ${selectedNetwork.network_range[0]} - ${selectedNetwork.network_range[1]}`;
          }
        }
      }

      setIpAddError(error);

      if (!error) {
        setFormData((prev) => ({
          ...prev,
          ip: value,
        }));
      }

      return;
    }
    if (key === "mac") {
      const error = validateMac(value);
      if (error) {
        setMacAddError(error);
      } else {
        setMacAddError("");
      }
    }
    if (key === "desc") {
      if (value && value.length > 32) {
        setDescError("Description cannot be more than 32 characters.");
      } else {
        setDescError("");
      }
    }
    if (key === "ip_address" || key === "server") {
      const error = validateIp(value);
      if (error) {
        setIpAddError(error);
      } else {
        setIpAddError("");
      }
    }
    if (key === "domain") {
      const error = validateDomain(value);
      if (error) {
        setDomainError(error);
      } else {
        setDomainError("");
      }
    }
  };

  useEffect(() => {
    if (deviceInfo === 'ap') {
      const updatedColumns = columns.filter(col => col.label !== 'Actions');
      setColumns(updatedColumns);
    }
  }, [deviceInfo])

  const fetchTableData = () => {
    switch (activeTab) {
      case "networks": {
        getAllNetworksData(selectedRow["deviceId"]);
        setIsModalOpen(false);
        break;
      }
      case "dhcp_reservation": {
        getDhcpReservationsData(selectedRow["deviceId"]);
        setIsAddAddressModalOpen(false);
        break;
      }
      case "static_routes": {
        getStaticRoutesData(selectedRow["deviceId"]);
        setIsStaticRoutesModalOpen(false);
        break;
      }
      case "multicast": {
        getLanMulticastData(selectedRow["deviceId"]);
        break;
      }
      case "dns_proxy": {
        getDnsProxyConfigData(selectedRow['deviceId']);
        setIsAddDomainModalOpen(false);
        setIsAddDnsServerModalOpen(false);
        break;
      }
      default: {
        console.warn(`Unhandled tab: ${activeTab}`);
      }
    }
  };

  // Skip the very first firing (tab mount) of the interfaces-status call:
  // InventoryPopup's centralized effect already refreshes it once when this
  // tab opens. Subsequent firings (sub-tab clicks, manual refresh) still call
  // it, since interfaces status is device-wide, not tied to one sub-tab.
  const skipFirstLinkStatusFetchRef = useRef(true);
  useEffect(() => {
    if(refreshIconClicked) {
      fetchTableData();
      if (skipFirstLinkStatusFetchRef.current) {
        skipFirstLinkStatusFetchRef.current = false;
      } else {
        getDeviceLinkStatusData(selectedRow['k4Id'], selectedRow['deviceId']);
      }
    }
  }, [refreshIconClicked, activeTab])

  // Same data fetches as fetchTableData, minus its modal-closing side effects
  // (polling shouldn't force-close a modal the operator has open), on a 30s
  // idle baseline (immediate on mount/sub-tab switch too), sped up to 2s
  // during an in-flight config change via startAction()/stopAction() below.
  // Interfaces status itself is refreshed centrally (InventoryPopup) and via
  // the sub-tab-switch effect above, not duplicated here.
  const fetchActiveTabData = (silent = false) => {
    switch (activeTab) {
      case "networks":
        getAllNetworksData(selectedRow["deviceId"], silent);
        break;
      case "dhcp_reservation":
        getDhcpReservationsData(selectedRow["deviceId"], silent);
        break;
      case "static_routes":
        getStaticRoutesData(selectedRow["deviceId"], silent);
        break;
      case "multicast":
        getLanMulticastData(selectedRow["deviceId"], silent);
        break;
      case "dns_proxy":
        getDnsProxyConfigData(selectedRow['deviceId'], silent);
        break;
      default:
        break;
    }
  };

  const lanAutoRefresh = useConfigAutoRefresh({
    fetchFns: [fetchActiveTabData],
    enabled: !!selectedRow?.deviceId,
    // The DNS cache toggle (handleToggle) has no tracked success/failure result
    // to detect completion from, so keep the fast-poll window short rather
    // than the 5-minute default - every other action here stops it sooner via
    // its own tracked response.
    maxActiveDurationMs: 45000,
  });

  useEffect(() => {
    if (!_.isEmpty(getAllNetworks)) {
      const data = getAllNetworks?.status ? getAllNetworks.networks : [];
      setLans(data);
      // setRefreshIconClicked(false);

      if (lanFilterAliases && lanFilterAliases.length > 0) {
        const filtered = data.filter((lan) =>
          lanFilterAliases.includes(lan.network_alias)
        );
        setFilteredLans(filtered);
      } else {
        setFilteredLans(data);
      }
      dispatch({ type: GET_ALL_NETWORKS, payload: {} })
    }
    if (!_.isEmpty(getStaticRoutes)) {
      const data = getStaticRoutes?.hasOwnProperty('routes') ? getStaticRoutes?.routes : [];
      setLans(data);
      dispatch({ type: GET_STATIC_ROUTES, payload: {} })
    }
    if (!_.isEmpty(getDhcpReservations)) {
      const data = getDhcpReservations?.hasOwnProperty('reservations') ? getDhcpReservations?.reservations : [];
      setLans(data);
      dispatch({ type: GET_DHCP_RESERVATIONS, payload: {} })
    }
    if (!_.isEmpty(getLanMulticast) && getLanMulticast?.status) {
      const data = getLanMulticast?.hasOwnProperty('data') ? getLanMulticast?.data : [];
      setLans(data);
      dispatch({ type: GET_LAN_MULTICAST, payload: {} })
    }
    if (!_.isEmpty(getDnsProxyConfig) && getDnsProxyConfig?.status) {
      const data = getDnsProxyConfig?.hasOwnProperty('data') ? getDnsProxyConfig?.data : [];
      setLans(data);
      setDnsServerColumns(prev =>
        prev.map(col =>
          col.key === "custom"
            ? {
                ...col,
                actions: data?.dnsForwarders?.length === 1 ? ["setting"] : ["setting", "delete"],
              }
            : col
        )
      );
      setDnsCasheEnabled(data?.dnsCacheEnabled)
      dispatch({ type: GET_DNS_PROXY_CONFIG, payload: {} })
    }
  }, [getAllNetworks, lanFilterAliases, getStaticRoutes, getDhcpReservations, getLanMulticast, getDnsProxyConfig]);

  useEffect(() => {
    if (_.isEmpty(getSetLanMulticast)) return;
    lanAutoRefresh.stopAction();
    notifyConfigActionComplete?.();
    if (getSetLanMulticast.status === true) {
      fetchTableData();
      dispatch({ type: GET_SET_LAN_MULTICAST, payload: {} });
    } else {
      setLans((prev) =>
        prev.map((item) =>
          item.id === row.id ? { ...item, active: row.active } : item
        )
      );
      dispatch({ type: GET_SET_LAN_MULTICAST, payload: {} });
    }
  }, [getSetLanMulticast])

  useEffect(() => {
    const stored = (window as any).__lanTabFilterAliases;
    if (stored) {
      setLanFilterAliases(stored);
      // Optional: clear so it's not reused next time
      delete (window as any).__lanTabFilterAliases;
    }
  }, []);

  const handleActionClick = (
    type: "setting" | "refresh" | "delete" | "portal" | "edit",
    headerKey: string,
    row: NetworkTableRow
  ) => {
    console.log(`Action "${type}" clicked on ${headerKey}`, row);
    setRow(row);
    switch (type) {
      case "delete":
        if(activeTab == 'networks') {
          setIsDeleteModalOpen(true);
        } else if(activeTab == 'static_routes') {
          setIsStataicRouteDeleteModalOpen(true);
        } else if(activeTab == 'dhcp_reservation') {
          setIsDhcpReservationDeleteModalOpen(true);
        } else if(activeTab == 'dns_proxy') {
          setIsDnsProxyDeleteModalOpen(true);
        }
        break;
      case "setting": {
        setIsEditPopup(true);
        if (activeTab === "networks") {
          setIsModalOpen(true);
          setFormData({
            vlan_id: row["vlan_id"],
            network_alias: row["network_alias"],
            interface_ip: `${row["interface_ip"]}/${netmaskToCIDR(row?.["netmask"])}`,
            netmask: row["netmask"],
            dhcp: row["dhcp"],
            profile_name: row["profile_name"],
            link_type: row["link_type"],
            id: row["id"],
            dhcp_gateway: row["dhcp_gateway"],
            dns_server: row["dns_server"],
            ip_pools: row["ip_pools"],
            isCaptive: row["isCaptive"] ? "enabled" : "disabled",
            is_mgmt: row["is_mgmt"] ? "enabled" : "disabled",
            device: row["device"],
            device_id: row["device_id"],
          });
        }

        if (activeTab === "static_routes") {
          setIsStaticRoutesModalOpen(true);
          setFormData({
            id: row["id"],
            source_address: row["source_address"],
            destination_address: row["destination_address"],
            gateway: row["gateway"],
          });
        }

        if (activeTab === "dhcp_reservation") {
          setIsAddAddressModalOpen(true);
          setFormData({
            id: row["id"],
            vlan_name: row["vlan_name"],
            vlan_id: row["vlan_id"],
            ip: row["ip"],
            mac: row["mac"],
            name: row["name"],
            desc: row["desc"],
            isCaptive: row['bypasscaptive'] ? "enabled" : "disabled"
          });
        }

        if(activeTab == 'dns_proxy' && row.hasOwnProperty('domain')) {
          setIsAddDomainModalOpen(true);
          setFormData({
            id: row["id"],
            ip_address: row["ip"],
            domain: row["domain"]
          });
        }

        if(activeTab == 'dns_proxy' && row.hasOwnProperty('server')) {
          setIsAddDnsServerModalOpen(true);
          setFormData({
            id: row["id"],
            server: row["server"]
          });
        }

        break;
      }
      default:
        console.warn(`Unhandled action type: ${type}`);
    }
  };

  useEffect(() => {
    if (!_.isEmpty(deleteLan) || !_.isEmpty(deleteStaticRoute) || !_.isEmpty(getDeleteDhcpReservation) || !_.isEmpty(getDeleteDnsProxyConfig) || !_.isEmpty(addWanInterface) || !_.isEmpty(updateWanInterface)) {
      lanAutoRefresh.stopAction();
      notifyConfigActionComplete?.();
    }
    if (!_.isEmpty(deleteLan) && deleteLan?.status == true) {
      fetchTableData();
      dispatch({ type: DELETE_LAN, payload: {} })
      setIsDeleteModalOpen(false);
    }
    if (!_.isEmpty(deleteStaticRoute) && deleteStaticRoute?.status == true) {
      fetchTableData();
      dispatch({ type: DELETE_STATIC_ROUTE, payload: {} })
      setIsStataicRouteDeleteModalOpen(false);
    }
    if (!_.isEmpty(getDeleteDhcpReservation) && getDeleteDhcpReservation?.status == true) {
      fetchTableData();
      dispatch({ type: GET_DELETE_DHCP_RESERVATION, payload: {} })
      setIsDhcpReservationDeleteModalOpen(false);
    }
    if (!_.isEmpty(getDeleteDnsProxyConfig) && getDeleteDnsProxyConfig?.status == true) {
      fetchTableData();
      dispatch({ type: GET_DELETE_DNS_PROXY_CONFIG, payload: {} })
      setIsDnsProxyDeleteModalOpen(false);
    }
    if (!_.isEmpty(addWanInterface) && addWanInterface?.status == true) {
      fetchTableData();
      dispatch({ type: ADD_WAN_INTERFACE, payload: {} });
      setFormData({});
    }
    if (!_.isEmpty(updateWanInterface) && updateWanInterface?.status == true) {
      fetchTableData();
      dispatch({ type: UPDATE_WAN_INTERFACE, payload: {} })
      setIsEditPopup(false);
      setFormData({});
    }
  }, [deleteLan, deleteStaticRoute, getDeleteDhcpReservation, getDeleteDnsProxyConfig, addWanInterface, updateWanInterface])

  useEffect(() => {
    if (isModalOpen) {
      getWanProfilesData(selectedRow['deviceId'], true);
      getFreeLanAccessInterfacesData(selectedRow['deviceId']);
    }
    if(isStaticRoutesModalOpen ||  isAddAddressModalOpen) {
      getLanIpRangesData(selectedRow['deviceId']);
    }
  }, [isModalOpen, isStaticRoutesModalOpen, isAddAddressModalOpen])

  useEffect(() => {
    if (!_.isEmpty(getWanProfiles) && getWanProfiles.status == true) {
      const data = getWanProfiles?.wan_profiles;
      setWanProfiles(data);
    }
    if (!_.isEmpty(getFreeLanAccessInterfaces) && getFreeLanAccessInterfaces.status == true) {
      const data = getFreeLanAccessInterfaces?.interfaces;
      setFreeLanAccessInterfaces(data);
    }
  }, [getWanProfiles, getFreeLanAccessInterfaces])

  const handleAddInterface = () => {
    lanAutoRefresh.startAction();
    notifyConfigAction?.();
    const selectedProfile = wanProfiles.find(profile => profile.profileName === formData.profile_name);
    const selectedLan = freeLanAccessInterfaces.find(device => device.alias === formData.device);
    
    // Calculate netmask from CIDR if interface_ip contains '/'
    let interface_ip = formData.interface_ip?.trim();
    let netmask = formData.netmask;

    if (interface_ip?.includes('/')) {
      const [ip, cidr] = interface_ip.split('/');
      interface_ip = ip.trim();
      netmask = cidrToNetmask(Number(cidr.trim()));
    }

    const payload = {
      data: {
        action: isEditPopup ? 'edit' : 'create',
        vlan_id: formData.vlan_id,
        network_alias: formData.network_alias,
        interface_ip: formData.interface_ip.split('/')[0],
        netmask: netmask,
        dhcp: formData.dhcp ? true : false,
        profile_name: formData.profile_name,
        profile_id: selectedProfile?.id,
        isCaptive: formData?.isCaptive == 'enabled' ? true : false,
        is_mgmt: formData?.is_mgmt == 'enabled' ? true : false,
        link_type: isEditPopup ? formData.link_type : 'LAN Trunk',
        DID: selectedRow['deviceId'],
        dhcp_gateway: formData.dhcp ? formData.dhcp_gateway : undefined,
        dns_server: formData.dhcp ? formData.dns_server : undefined,
        ip_pools: formData.dhcp ? formData.ip_pools : undefined,
        device_id: isEditPopup && formData?.link_type === 'LAN Access' ? formData?.device_id : formData?.link_type === 'LAN Access' ? selectedLan?.id : undefined,
        device: isEditPopup && formData?.link_type === 'LAN Access' ? formData?.device : undefined,
        ...(isEditPopup && { id: formData?.id })
      }
    }
    isEditPopup ? updateWanInterfaceData(payload, 'updateNetwork') : addWanInterfaceData(payload, 'addNewNetwork');
  };

  const handleClosePopup = () => {
    dispatch({ type: ADD_WAN_INTERFACE, payload: {} });
    dispatch({ type: UPDATE_WAN_INTERFACE, payload: {} });
    setIsEditPopup(false);
    setFormData({});
    setRow({});
    switch(activeTab) {
      case 'networks': {
        setIsModalOpen(false);
        setVidError('');
        setIpError('');
        setDhcpGatewayError('');
        setDnsError('');
        setIpPoolsError('');
        break;
      }
      case 'static_routes': {
        setIsStaticRoutesModalOpen(false);
        setGatewayError('');
        setDestinationAddressError('');
        setSourceAddressError('');
        break;
      }
      case 'dhcp_reservation': {
        setIsAddAddressModalOpen(false);
        setIpAddError('');
        setMacAddError('');
        break;
      }
      case 'dns_proxy': {
        setIsAddDomainModalOpen(false);
        setIsAddDnsServerModalOpen(false);
        setIpAddError('');
        setDomainError('');
        break;
      }
    }
  }

  const isFormValid = (): boolean => {
    if (!formData) return false;
    const { network_alias, vlan_id, profile_name, interface_ip, dhcp, dhcp_gateway, dns_server, ip_pools, source_address, destination_address, gateway, 
      vlan_name, ip, mac, name, desc, ip_address, domain, server
     } = formData;
    if (activeTab === "networks") {
      if (!network_alias || vlan_id === undefined || vlan_id === "" || !profile_name || !interface_ip) {
        return false;
      }
      const vlanNum = Number(vlan_id);
      if (isNaN(vlanNum) || vlanNum < 1 || vlanNum > 4095 || vidError) {
        return false;
      }
      if (ipError) {
        return false;
      }
      if (dhcp) {
        if (!dhcp_gateway || dhcpGatewayError || !dns_server || dnsError || !ip_pools || ipPoolsError) {
          return false;
        }
      }
      if (aliasError) {
        return false;
      }
    }

    if (activeTab === "static_routes") {
      if (!destination_address || !gateway) {
        return false;
      }
      if (destinationAddressError || gatewayError) {
        return false;
      }
      if (source_address && sourceAddressError) {
        return false;
      }
    }

    if (activeTab === "dhcp_reservation") {
      if (!vlan_name || !name || !ip || !mac) {
        return false;
      }

      // desc is optional but must be <= 32 characters if provided
      if (desc && desc.length > 32) {
        return false;
      }

      if (ipAddError || macAddError || descError) {
        return false;
      }
    }

    if (activeTab === "dns_proxy" && isAddDomainModalOpen) {
      if (!ip_address || !domain) {
        return false;
      }
      if (ipAddError || domainError) {
        return false;
      }
    }
    if (activeTab === "dns_proxy" && isAddDnsServerModalOpen) {
      if (!server) {
        return false;
      }
      if (ipAddError) {
        return false;
      }
    }
    return true;
  };

  const tabs = [
    { tabName: 'Networks', tabValue: 'networks', pathName: '/inventory' },
    { tabName: 'DHCP Reservation', tabValue: 'dhcp_reservation', pathName: '/inventory', disable: selectedRow?.licenseTier == "T103" ? 'Yes' : 'No' },
    { tabName: 'DNS Proxy', tabValue: 'dns_proxy', pathName: '/inventory', disable: selectedRow?.licenseTier == "T103" ? 'Yes' : 'No' },
    { tabName: 'Static Routes', tabValue: 'static_routes', pathName: '/inventory', disable: selectedRow?.licenseTier == "T103" ? 'Yes' : 'No' },
    { tabName: 'Multicast', tabValue: 'multicast', pathName: '/inventory', disable: selectedRow?.licenseTier == "T103" ? 'Yes' : 'No' },
  ];

  const doNavigateTab = (pathname, tabName) => {
    setActiveTab(tabName);
    setLans([]);
  }

  const handleAddStaticRoute = () => {
    lanAutoRefresh.startAction();
    notifyConfigAction?.();
    const payload = {
      data: {
        k4Id: selectedRow['k4Id'],
        DID: selectedRow['deviceId'],
        source: "OE",
        interface: "lan",
        source_address: formData.source_address !== undefined ? formData.source_address : "",
        destination_address: formData.destination_address,
        gateway: formData.gateway,
        ...(isEditPopup && { id: formData?.id })
      }
    }
    isEditPopup ? updateWanInterfaceData(payload, 'updateStaticRoute') : addWanInterfaceData(payload, 'addStaticRoute');
  }

  const handleAddDhcpRedervation = () => {
    const selectedNetwork = ipRanges?.networks?.find(an => an?.network_alias === formData?.vlan_name);
    const nameRegex = /^[A-Za-z][A-Za-z0-9.-]*$/;
    if (!nameRegex.test(formData?.name)) {
      toast.error("Invalid Device Name. Name should be alphanumeric, start with a character, and only '-' or '.' are allowed. Spaces are not allowed.", {
        position: toast.POSITION.BOTTOM_LEFT,
      })
      return false;
    }

    lanAutoRefresh.startAction();
    notifyConfigAction?.();
    const payload = {
      data: {
        DID: selectedRow['deviceId'],
        vlan_name: selectedNetwork?.network_alias,
        vlan_rec_id: selectedNetwork?.id,
        vlan_id: selectedNetwork?.vlan_id,
        ip: formData.ip,
        mac: formData.mac,
        name: formData.name,
        desc: formData.desc,
        bypasscaptive: formData?.isCaptive == 'enabled' ? true : false,
        ...(isEditPopup && { id: formData?.id })
      }
    }
    isEditPopup ? updateWanInterfaceData(payload, 'updateMACIPReservation') : addWanInterfaceData(payload, 'addMACIPReservation');
  }

  const handleAddDomain  = () => {
    lanAutoRefresh.startAction();
    notifyConfigAction?.();
    const payload = {
        DID: selectedRow['deviceId'],
        ip: formData?.ip_address,
        domain: formData?.domain,
        ...(isEditPopup && { id: formData?.id })
      }
    isEditPopup ? updateWanInterfaceData(payload, 'updateDNSDomainMapping') : addWanInterfaceData(payload, 'createDNSDomainMapping');
  }

  const handleAddServer  = () => {
    lanAutoRefresh.startAction();
    notifyConfigAction?.();
    const payload = {
        DID: selectedRow['deviceId'],
        server: formData?.server,
        ...(isEditPopup && { id: formData?.id })
      }
    isEditPopup ? updateWanInterfaceData(payload, 'updateDNSForwarder') : addWanInterfaceData(payload, 'createDNSForwarder');
  }

  useEffect(() => {
    if (!_.isEmpty(getLanIpRanges) && getLanIpRanges?.status) {
      const list = getLanIpRanges ? getLanIpRanges : [];
      setIpRanges(list);
    }
  }, [getLanIpRanges])

  const handleToggle = (headerKey: string, value: boolean) => {
    const payload = {
      DID: selectedRow['deviceId'],
      [headerKey]: value,
    };
    lanAutoRefresh.startAction();
    notifyConfigAction?.();
    getEnableDisableDnsProxyData(payload);
  };

  const handleToggleMulticast = (headerKey: string, value: boolean, row: NetworkTableRow) => {
    setLans((prev) =>
      prev.map((item) =>
        item.id === row.id ? { ...item, [headerKey]: value } : item
      )
    );
    const payload = {
      DID: selectedRow['deviceId'],
      vlan_id: row['vlan_id'],
      vlan_rec_id: row['vlan_rec_id'],
      vlan_name: row['vlan_name'],
      [headerKey]: value
    };
    setRow(row);
    lanAutoRefresh.startAction();
    notifyConfigAction?.();
    getSetLanMulticastData(payload);
  };

  return (<div className="internalPadding">
    <TabsComponent tabs={tabs} handleChangeTab={doNavigateTab} activeTab={activeTab} isSubTabs={true} removemarginTop={true} />
    <div className="tab-content lan-tab-contnent">
      {activeTab == 'networks' && <Container maxWidth="xl" className="app-container">
        <Box my={0}>
          <NetworkTable
            data={filteredLans}
            columns={columns}
            showFilterBar
            addButtonLabel="Add LAN Network"
            onAddClick={() => {
              setIsModalOpen(true);
              setFormData({ isCaptive: "disabled", is_mgmt: "disabled" });
              setRow({});
            }}
            onActionClick={handleActionClick}
            deviceInfo={deviceInfo}
          />
        </Box>
      </Container>}
      {activeTab == 'dhcp_reservation' && <Container maxWidth="xl" className="app-container">
        <Box my={0}>
          <NetworkTable
            data={lans}
            columns={dhcpColumns}
            showFilterBar
            addButtonLabel="Add Reservation"
            onAddClick={() => {
              setIsAddAddressModalOpen(true);
              setRow({});
            }}
            onActionClick={handleActionClick}
          />
        </Box>
      </Container>}
      {activeTab == 'dns_proxy' && <Container maxWidth="xl" className="app-container">
        <CheckboxWithAction
          label="DNS Cache(Enable local DNS caching of DNS lookups to improve performance)"
          checked={dnsCasheEnabled}
          onToggle={(checked) => {
            setDnsCasheEnabled(checked);
            handleToggle('dnsCacheEnabled', checked);
          }}
        />
        <CheckboxWithAction
          label="Enable DNS Host Overrides"
          checked={dnsHostOverrideEnabled}
          onToggle={setDnsHostOverrideEnabled}
          buttonLabel="Add Domain / Host Mapping"
          onButtonClick={() => setIsAddDomainModalOpen(true)}
          showToggle={false}
        />
        <Box my={0}>
          <NetworkTable
            data={lans?.hasOwnProperty('domainMappings') ? lans?.domainMappings : []}
            columns={domainColumns}
            onActionClick={handleActionClick}
            maxHeight = '135px'
          />
        </Box>
        <Box mt={3}></Box>
        <CheckboxWithAction
          label="Enable DNS Forwarder"
          checked={dnsForwarderEnabled}
          onToggle={setDNSForwarderEnabled}
          buttonLabel="Add DNS Server"
          onButtonClick={() => setIsAddDnsServerModalOpen(true)}
          showToggle={false}
        />
        <Box my={0}>
          <NetworkTable
            data={lans?.hasOwnProperty('dnsForwarders') ? lans?.dnsForwarders : []}
            columns={dnsServerColumns}
            onActionClick={handleActionClick}
            maxHeight = '135px'
          />
        </Box>
      </Container>}
      {activeTab == 'static_routes' && <Container maxWidth="xl" className="app-container">
        <Box my={0}>
          <NetworkTable
            data={lans}
            columns={staticRoutesColumns}
            showFilterBar
            addButtonLabel="Add Static Route"
            onAddClick={() => {
              setIsStaticRoutesModalOpen(true);
              setRow({});
            }}
            onActionClick={handleActionClick}
          />
        </Box>
      </Container>}
      {activeTab == 'multicast' && <Container maxWidth="xl" className="app-container">
        <Box my={0} mt={1}>
          <NetworkTable
            data={lans}
            columns={multicastColumns}
            onActionClick={handleActionClick}
            onToggle={handleToggleMulticast}
          />
        </Box>
      </Container>}

      {getAllNetworksLoading || getWanProfilesLoading || addWanInterfaceLoading || updateWanInterfaceLoading || deleteLANLoading || getFreeLanAccessInterfacesLoading || deviceLinkStatusLoading || getStaticRoutesLoading || deleteStaticRouteLoading || getLanIpRangesLoading || getDhcpReservationsLoading || getDeleteDhcpReservationLoading || getEnableDisableDnsProxyLoading || getLanMulticastLoading || getSetLanMulticastLoading || getDnsProxyConfigLoading ? (
        <CustomLoader
          showLoader={true}
          loadingText={"Please wait..."}
        />
      ) : null}
    </div>

    <AddEditInterfaceModal
      open={isModalOpen}
      onClose={handleClosePopup}
      onSave={handleAddInterface}
      saveText={isEditPopup ? 'Update' : 'Add'}
      disableSave={!isFormValid()}
      title={isEditPopup ? 'Edit Network' : 'Add Network'}
      layout={[
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Network Alias"
                  isInput
                  value={formData?.network_alias}
                  onChange={handleChange("network_alias")}
                  placeholder="Enter alias"
                  error={aliasError}
                />
              ),
              gridSize: 9,
            },
            {
              component: (
                <LabelValueDisplay
                  type='number'
                  label="VLAN ID"
                  isInput
                  value={formData?.vlan_id}
                  onChange={handleChange("vlan_id")}
                  placeholder="Enter VLAN"
                  error={vidError}
                  disabled={isEditPopup}
                />
              ),
              gridSize: 3,
            },
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Interface IP / Subnet"
                  isInput
                  value={formData?.interface_ip}
                  onChange={handleChange("interface_ip")}
                  placeholder="Enter IP/Subnet"
                  error={ipError}
                />
              ),
              gridSize: 6,
            },
            {
              component: (
                // <LabelValueDisplay
                //   label="LAN Type"
                //   isDropdown
                //   dropdownOptions={["LAN Trunk", "LAN Access"]}
                //   value={formData?.link_type}
                //   onChange={handleChange("link_type")}
                //   placeholder="Select LAN Type"
                //   disabled={isEditPopup}
                // />
                <LabelValueDisplay
                  label="Profile Name"
                  isDropdown
                  dropdownOptions={wanProfiles?.map((p) => p.profileName)}
                  value={formData?.profile_name}
                  onChange={handleChange("profile_name")}
                  placeholder="Enter Profile Name"
                />
              ),
              gridSize: 6,
            },
          ],
        },
        // {
        //   columns: [
        //     {
        //       component: (
        //         <LabelValueDisplay
        //           label="Profile Name"
        //           isDropdown
        //           dropdownOptions={wanProfiles?.map((p) => p.profileName)}
        //           value={formData?.profile_name}
        //           onChange={handleChange("profile_name")}
        //           placeholder="Enter Profile Name"
        //         />
        //       ),
        //       gridSize: 6,
        //     },
        //     ...(formData?.link_type === 'LAN Access'
        //       ? [
        //         {
        //           component: (
        //             <LabelValueDisplay
        //               label="Lan"
        //               isDropdown
        //               disabled={isEditPopup ? true : false}
        //               dropdownOptions={freeLanAccessInterfaces?.map((i) => i.alias)}
        //               value={formData?.device}
        //               onChange={handleChange("device")}
        //               placeholder="Select Lan"
        //             />
        //           ),
        //           gridSize: 6,
        //         },
        //       ]
        //       : [])
        //   ],
        // },
        {
          columns: [
            {
              component: (
                <ToggleRadioGroup
                  label="Management Network"
                  value={formData?.is_mgmt}
                  onChange={handleChange('is_mgmt')}
                  disabled={formData?.link_type == 'LAN Access'}
                />
              ),
              gridSize: 6,
            },
            ...(selectedRow?.['tierValue']?.startsWith('T104')
              ? [
            {
              component: (
                <ToggleRadioGroup
                  label="Captive Access Network"
                  value={formData?.isCaptive}
                  onChange={handleChange('isCaptive')}
                  disabled={formData?.is_mgmt == 'enabled'}
                />
              ),
              gridSize: 6,
            }] : [])
          ],
        },
        {
          columns: [
            {
              component: (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData?.dhcp || false}
                      onChange={handleChange("dhcp")}
                      size="small"
                      disabled={formData?.is_mgmt == "enabled"}
                    />
                  }
                  label={
                    <span style={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 500,
                      fontSize: '12px',
                      color: 'rgba(110, 112, 121, 1)'
                    }}>
                      DHCP
                    </span>
                  }
                />
              ),
              gridSize: 12,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Default DHCP Gateway"
                  isInput
                  value={formData?.dhcp_gateway}
                  onChange={handleChange("dhcp_gateway")}
                  placeholder="Enter DHCP Gateway"
                  disabled={!formData?.dhcp}
                  error={dhcpGatewayError}
                />
              ),
              gridSize: 6,
            },
            {
              component: (
                <LabelValueDisplay
                  label="DNS Servers"
                  isInput
                  value={formData?.dns_server}
                  onChange={handleChange("dns_server")}
                  placeholder="Enter DNS Servers"
                  disabled={!formData?.dhcp || formData?.isCaptive === "enabled"}  
                  error={dnsError}
                />
              ),
              gridSize: 6,
            },

          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="IP Pools"
                  isInput
                  value={formData?.ip_pools}
                  onChange={handleChange("ip_pools")}
                  placeholder="Enter IP Pools"
                  disabled={!formData?.dhcp}
                  error={ipPoolsError}
                />
              ),
              gridSize: 12,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {!_.isEmpty(updateWanInterface) && updateWanInterface.msg}
                </span>
              ),
              gridSize: 12,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {!_.isEmpty(addWanInterface) && addWanInterface.msg}
                </span>
              ),
              gridSize: 12,
            },
          ],
        },
      ]}
    />
    <AddEditInterfaceModal
      open={isAddAddressModalOpen}
      onClose={handleClosePopup}
      onSave={handleAddDhcpRedervation}
      saveText={isEditPopup ? 'Update' : 'Add'}
      disableSave={!isFormValid()}
      title={isEditPopup ? 'Edit DHCP Reservation' : 'Add DHCP Reservation'}
      layout={[
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Network Alias"
                  isDropdown
                  dropdownOptions={ipRanges?.networks?.map(n => n.network_alias)}
                  value={formData?.vlan_name}
                  onChange={handleChange("vlan_name")}
                  placeholder="Select Network"
                  disabled={isEditPopup}
                />
              ),
              gridSize: 9,
            },
            {
              component: (
                <LabelValueDisplay
                  type='number'
                  label="VLAN ID"
                  isInput
                  value={formData?.vlan_id}
                  onChange={handleChange("vlan_id")}
                  placeholder="Enter VLAN"
                  disabled={true}
                />
              ),
              gridSize: 3,
            },
          ],
        },
        {
          columns: [
            ...(ipRanges?.networks?.find((n) => n?.network_alias === formData?.vlan_name && n?.isCaptive == true)
              ? [
            {
              component: (
                <ToggleRadioGroup
                  label="Captive Bypass"
                  value={formData?.isCaptive}
                  onChange={handleChange('isCaptive')}
                />
              ),
              gridSize: 12,
            }] : [])
          ],
        },
        {
          columns: [
            {
              component: (
                <Box height="21px" />
              ),
              gridSize: 12,
            }
          ]
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="IP Address"
                  isInput
                  value={formData?.ip}
                  onChange={handleChange("ip")}
                  placeholder="Enter IP Address"
                  error={ipAddError}
                  disabled={!formData?.vlan_name}
                />
              ),
              gridSize: 6,
            },
            {
              component: (
                <LabelValueDisplay
                  label="MAC Address"
                  isInput
                  value={formData?.mac}
                  onChange={handleChange("mac")}
                  placeholder="Enter MAC Address"
                  error={macAddError}
                  disabled={isEditPopup}
                />
              ),
              gridSize: 6,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Device"
                  isInput
                  value={formData?.name}
                  onChange={handleChange('name')}
                  placeholder="Enter Device"
                />
              ),
              gridSize: 12,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Description"
                  isInput
                  value={formData?.desc}
                  onChange={handleChange('desc')}
                  placeholder="Enter Description"
                  error={descError}
                />
              ),
              gridSize: 12,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {!_.isEmpty(updateWanInterface) && updateWanInterface.msg}
                </span>
              ),
              gridSize: 12,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {!_.isEmpty(addWanInterface) && addWanInterface.msg}
                </span>
              ),
              gridSize: 12,
            },
          ],
        }
      ]}
    />
    <AddEditInterfaceModal
      open={isAddDomainModalOpen}
      onClose={handleClosePopup}
      onSave={handleAddDomain}
      disableSave={!isFormValid()}
      saveText={isEditPopup ? 'Update' : 'Add'}
      title={isEditPopup ? 'Edit Domain / Host Mapping' : 'Add Domain / Host Mapping'}
      layout={[
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="IP Address"
                  isInput
                  value={formData?.ip_address}
                  onChange={handleChange("ip_address")}
                  placeholder="Enter IP Address"
                  error={ipAddError}
                />
              ),
              gridSize: 12,
            },
            {
              component: (
                <LabelValueDisplay
                  label="Host Name / Domain"
                  isInput
                  value={formData?.domain}
                  onChange={handleChange("domain")}
                  placeholder="Enter Host Name / Domain"
                  error={domainError}
                />
              ),
              gridSize: 12,
            },
          ],
        },
        {
          columns: [
            {
              component: (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {!_.isEmpty(updateWanInterface) && updateWanInterface.msg}
                </span>
              ),
              gridSize: 12,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {!_.isEmpty(addWanInterface) && addWanInterface.msg}
                </span>
              ),
              gridSize: 12,
            },
          ],
        }
      ]}
    />
    <AddEditInterfaceModal
      open={isAddDnsServerModalOpen}
      onClose={handleClosePopup}
      onSave={handleAddServer}
      disableSave={!isFormValid()}
      saveText={isEditPopup ? 'Update' : 'Add'}
      title={isEditPopup ? 'Edit DNS Server' : 'Add DNS Server'}
      layout={[
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="DNS Server"
                  isInput
                  value={formData?.server}
                  onChange={handleChange("server")}
                  placeholder="Enter DNS Server"
                  error={ipAddError}
                />
              ),
              gridSize: 12,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {!_.isEmpty(updateWanInterface) && updateWanInterface.msg}
                </span>
              ),
              gridSize: 12,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {!_.isEmpty(addWanInterface) && addWanInterface.msg}
                </span>
              ),
              gridSize: 12,
            },
          ],
        }
      ]}
    />
    <AddEditInterfaceModal
      open={isStaticRoutesModalOpen}
      onClose={handleClosePopup}
      onSave={handleAddStaticRoute}
      saveText={isEditPopup ? 'Update' : 'Add'}
      title={isEditPopup ? 'Edit Static Route' : 'Add Static Route'}
      disableSave={!isFormValid()}
      layout={[
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Destination IP"
                  isInput
                  value={formData?.destination_address}
                  onChange={handleChange("destination_address")}
                  placeholder="Enter Destination IP"
                  error={destinationAddressError}
                />
              ),
              gridSize: 12,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Gateway IP"
                  isInput
                  value={formData?.gateway}
                  onChange={handleChange("gateway")}
                  placeholder="Enter Gateway IP"
                  error={gatewayError}
                />
              ),
              gridSize: 12,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <LabelValueDisplay
                  label="Source IP (Optional)"
                  isInput
                  value={formData?.source_address}
                  onChange={handleChange("source_address")}
                  placeholder="Enter Source IP"
                  error={sourceAddressError}
                />
              ),
              gridSize: 12,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {!_.isEmpty(updateWanInterface) && updateWanInterface.msg}
                </span>
              ),
              gridSize: 12,
            }
          ],
        },
        {
          columns: [
            {
              component: (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {!_.isEmpty(addWanInterface) && addWanInterface.msg}
                </span>
              ),
              gridSize: 12,
            },
          ],
        }
      ]}
    />

    {row.network_alias && (
      <DeleteWANProfileModal
        open={isDeleteModalOpen}
        onClose={() => {setIsDeleteModalOpen(false); dispatch({type: DELETE_LAN, payload: {}})}}
        onConfirm={() => {
          lanAutoRefresh.startAction();
          notifyConfigAction?.();
          deleteLanData(selectedRow['deviceId'], row['vlan_id'], row['id']);
        }}
        profileName={row.network_alias}
        errorMessage={deleteLan?.status == false && deleteLan?.msg ? deleteLan?.msg : ''}
      />
    )}
    {row?.destination_address && (
      <DeleteWANProfileModal
        open={isStaticRouteDeleteModalOpen}
        onClose={() => {setIsStataicRouteDeleteModalOpen(false); dispatch({type: DELETE_STATIC_ROUTE, payload: {}})}}
        onConfirm={() => {
          lanAutoRefresh.startAction();
          notifyConfigAction?.();
          deleteStaticRouteData(selectedRow['k4Id'], selectedRow['deviceId'], row['id']);
        }}
        profileName={row?.destination_address}
        errorMessage={deleteStaticRoute?.status == false && deleteStaticRoute?.msg ? deleteStaticRoute?.msg : ''}
      />
    )}
    {row?.name && (
      <DeleteWANProfileModal
        open={isDhcpReservationDeleteModalOpen}
        onClose={() => {setIsDhcpReservationDeleteModalOpen(false); dispatch({type: GET_DELETE_DHCP_RESERVATION, payload: {}})}}
        onConfirm={() => {
          lanAutoRefresh.startAction();
          notifyConfigAction?.();
          getDeleteDhcpReservationData(selectedRow['deviceId'], row['id']);
        }}
        profileName={row?.name}
        errorMessage={getDeleteDhcpReservation?.status == false && getDeleteDhcpReservation?.msg ? getDeleteDhcpReservation?.msg : ''}
      />
    )}
    {row?.ip && (
      <DeleteWANProfileModal
        open={isDnsProxyDeleteModalOpen}
        onClose={() => {setIsDnsProxyDeleteModalOpen(false); dispatch({type: GET_DELETE_DNS_PROXY_CONFIG, payload: {}})}}
        onConfirm={() => {
          lanAutoRefresh.startAction();
          notifyConfigAction?.();
          getDeleteDnsProxyConfigData('deleteDNSDomainMapping', selectedRow['deviceId'], row['id']);
        }}
        profileName={row?.ip}
        errorMessage={getDeleteDnsProxyConfig?.status == false && getDeleteDnsProxyConfig?.msg ? getDeleteDnsProxyConfig?.msg : ''}
      />
    )}
    {row?.server && (
      <DeleteWANProfileModal
        open={isDnsProxyDeleteModalOpen}
        onClose={() => {setIsDnsProxyDeleteModalOpen(false); dispatch({type: GET_DELETE_DNS_PROXY_CONFIG, payload: {}})}}
        onConfirm={() => {
          lanAutoRefresh.startAction();
          notifyConfigAction?.();
          getDeleteDnsProxyConfigData('deleteDNSForwarder', selectedRow['deviceId'], row['id']);
        }}
        profileName={row?.server}
        errorMessage={getDeleteDnsProxyConfig?.status == false && getDeleteDnsProxyConfig?.msg ? getDeleteDnsProxyConfig?.msg : ''}
      />
    )}
  </div>
  );
}

const mapStateToProps = (state) => ({
  getAllNetworks: state.authReducer.getAllNetworks,
  deleteLan: state.authReducer.deleteLan,
  deleteStaticRoute: state.authReducer.deleteStaticRoute,
  deleteStaticRouteLoading: state.authReducer.deleteStaticRouteLoading,
  addWanInterface: state.authReducer.addWanInterface,
  updateWanInterface: state.authReducer.updateWanInterface,
  getWanProfiles: state.authReducer.getWanProfiles,
  getAllNetworksLoading: state.authReducer.getAllNetworksLoading,
  getWanProfilesLoading: state.authReducer.getWanProfilesLoading,
  addWanInterfaceLoading: state.authReducer.addWanInterfaceLoading,
  updateWanInterfaceLoading: state.authReducer.updateWanInterfaceLoading,
  deleteLANLoading: state.authReducer.deleteLANLoading,
  getFreeLanAccessInterfaces: state.authReducer.getFreeLanAccessInterfaces,
  getFreeLanAccessInterfacesLoading: state.authReducer.getFreeLanAccessInterfacesLoading,
  deviceLinkStatusLoading: state.authReducer.getDeviceLinkStatusLoading,
  getStaticRoutes: state.authReducer.getStaticRoutes,
  getStaticRoutesLoading: state.authReducer.getStaticRoutesLoading,
  getLanIpRanges: state.authReducer.getLanIpRanges,
  getLanIpRangesLoading: state.authReducer.getLanIpRangesLoading,
  getDhcpReservations: state.authReducer.getDhcpReservations,
  getDhcpReservationsLoading: state.authReducer.getDhcpReservationsLoading,
  getDeleteDhcpReservation: state.authReducer.getDeleteDhcpReservation,
  getDeleteDhcpReservationLoading: state.authReducer.getDeleteDhcpReservationLoading,
  getEnableDisableDnsProxy: state.authReducer.getEnableDisableDnsProxy,
  getEnableDisableDnsProxyLoading: state.authReducer.getEnableDisableDnsProxyLoading,
  getLanMulticast: state.authReducer.getLanMulticast,
  getLanMulticastLoading: state.authReducer.getLanMulticastLoading,
  getSetLanMulticast: state.authReducer.getSetLanMulticast,
  getSetLanMulticastLoading: state.authReducer.getSetLanMulticastLoading,
  getDnsProxyConfig: state.authReducer.getDnsProxyConfig,
  getDnsProxyConfigLoading: state.authReducer.getDnsProxyConfigLoading,
  getDeleteDnsProxyConfig: state.authReducer.getDeleteDnsProxyConfig,
  getDeleteDnsProxyConfigLoading: state.authReducer.getDeleteDnsProxyConfigLoading,
});

export default withRouter(
  connect(mapStateToProps, { getAllNetworksData, deleteLanData, updateWanInterfaceData, addWanInterfaceData, getWanProfilesData, getFreeLanAccessInterfacesData, getDeviceLinkStatusData, getStaticRoutesData, deleteStaticRouteData, getLanIpRangesData, getDhcpReservationsData, getDeleteDhcpReservationData, getEnableDisableDnsProxyData, getLanMulticastData, getSetLanMulticastData, getDnsProxyConfigData, getDeleteDnsProxyConfigData })(LANTab)
)